import { useSelector } from 'react-redux'
import { selectFormsState } from 'redux/appStore'

export const useCallFormState = () => {
  const forms = useSelector(selectFormsState)
  return forms && forms.CallForm && forms.CallForm.getState && forms.CallForm.getState()
}

export default useCallFormState
